import { useSyncExternalStore } from "react";
import { onPrefs, pushPref } from "@/lib/prefsSync";

/* Which sidebar groups are folded; groups start folded and an explicit `false` means the user opened it. Remembered per account (synced) and per browser. */
const KEY = "rh.sidebar";
let state = {};
try { state = JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { state = {}; }
const subs = new Set();
const set = (next, push = true) => {
  state = next;
  localStorage.setItem(KEY, JSON.stringify(state));
  subs.forEach((fn) => fn());
  if (push) pushPref("sidebar", state);
};
onPrefs("sidebar", { apply: (v) => set(v && typeof v === "object" ? v : {}, false), read: () => state });

export const useSidebarPrefs = () => useSyncExternalStore((fn) => { subs.add(fn); return () => subs.delete(fn); }, () => state);
export const isCollapsed = (prefs, id) => prefs[id] !== false;
export const toggleGroup = (id) => set({ ...state, [id]: !isCollapsed(state, id) });

/* Pinned shortcuts live in the same synced object under `_pins` (ordered item ids such as "albums" or "playlist:<id>"). */
export const pinsOf = (prefs) => (Array.isArray(prefs._pins) ? prefs._pins : []);
export const pinItem = (id, index = null) => {
  const rest = pinsOf(state).filter((x) => x !== id);
  const at = index === null || index > rest.length ? rest.length : Math.max(0, index);
  set({ ...state, _pins: [...rest.slice(0, at), id, ...rest.slice(at)] });
};
export const unpinItem = (id) => set({ ...state, _pins: pinsOf(state).filter((x) => x !== id) });
